import PageTerraform from 'hcp/components/page/terraform';

<template><PageTerraform @model={{@controller.model}} /></template>
